import { render, staticRenderFns } from "./ContentGdComponent.vue?vue&type=template&id=882a3a3a&scoped=true"
import script from "./ContentGdComponent.vue?vue&type=script&lang=js"
export * from "./ContentGdComponent.vue?vue&type=script&lang=js"
import style0 from "./ContentGdComponent.vue?vue&type=style&index=0&id=882a3a3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882a3a3a",
  null
  
)

export default component.exports